// client/src/pages/PaymentSuccessWrapper.js

import React, { useEffect, useState } from 'react';
import { loadStripe } from '@stripe/stripe-js';
import { Elements } from '@stripe/react-stripe-js';
import PaymentSuccess from './PaymentSuccess';

// load your publishable key
const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PK);

export default function PaymentSuccessWrapper() {
  const [clientSecret, setClientSecret] = useState(null);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const cSec = params.get('payment_intent_client_secret');
    setClientSecret(cSec);
  }, []);

  if (!clientSecret) {
    return <div className="p-4 mt-16">No clientSecret found or loading...</div>;
  }

  const appearance = { theme: 'stripe' };
  const options = { clientSecret, appearance };

  return (
    <Elements stripe={stripePromise} options={options}>
      <PaymentSuccess />
    </Elements>
  );
}
